<div *ngIf="shouldEnforceLogin">

  <li class="nav-item" *ngIf="isLoggedIn == false">

    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Log
      In</button>

  </li>

  <li class="nav-item" *ngIf="isLoggedIn">

    <button type="button" class="btn btn-primary" (click)="logOut($event)">Log Out</button>

  </li>

</div>



<!-- 
  Modal
For ref
https://getbootstrap.com/docs/5.0/components/modal/
-->
<div class="modal fade" id="staticBackdrop" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">

  <div class="modal-dialog" #modalDialog>

    <div class="modal-content">

      <div class="modal-header">

        <h5 class="modal-title" id="staticBackdropLabel">Login page from src using iframe</h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>

      <div class="modal-body">

        <div class="container-fluid" *ngIf="loginUrl">
          <iframe [src]="loginUrl | safe" align="middle" width="100%" height="450" frameborder="0"></iframe>
        </div>
      </div>

      <!-- hidden but we still use the close button  -->
      <div class="modal-footer" [hidden]="true">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>

    </div>

  </div>

</div>